<template>
  <div class="sidepanel-test-item mb-2" v-if="unit && unit.countLearnPercent">
    <div v-if="showPreTestButton && canTest">
      <vs-button
        color="primary" icon-pack="feather" icon="icon-check-circle"
        @click.native="onStartTestClick(unit, 'pretest')"
      >
        {{ $t("virtual-class.start-pretest") }}
      </vs-button>

      <vs-divider></vs-divider>
    </div>

    <div
      v-if="showPostTestButton && canTest"
      class="mb-2">
      <vs-button
        color="primary" icon-pack="feather" icon="icon-check-circle"
        @click="onStartTestClick(unit, 'posttest')"
      >
        {{ $t("virtual-class.start-posttest") }}
      </vs-button>
      <vs-divider></vs-divider>
    </div>

  </div>
</template>

<script>

export default {
  props: [
    'unit',
    'canTest',
  ],
  data() {
    return {
      percentThatCanDoPostTest: 60,
    }
  },
  computed: {
    showPreTestButton(){
      if(!this.unit.studentUnitTest.isPretestDone){
        return true;
      }
      return false
    },
    showPostTestButton() {
      if(this.unit.studentUnitTest.isPretestDone
      && !this.unit.studentUnitTest.isPosttestDone
      && this.unit.studentUnitLearn.learnPercent >= this.percentThatCanDoPostTest){
        return true;
      }
      return false
    },
  },
  methods: {
    onStartTestClick(unit, examMode){
      this.$emit('handlerStartTestClick', {unit, examMode});
    }
  },
}
</script>

<style>

</style>
